import { View, Text } from "@adobe/react-spectrum";
import { MessageIcon } from "../../common/Icons";
import { setSelectedTab } from "../../../actions/common";
import storeRTK from "../../../store/storeRTK";

const NoActiveCase = (props: any) => {
  const switchHistoryTab = (e: any) => {
    e.preventDefault();
    storeRTK.dispatch(setSelectedTab('History'));
  }
  const isCaseTab = props?.isCaseTab || false;
  return (
    <>
      <View UNSAFE_className="noActiveCases">
        <View UNSAFE_className="noActiveCasesIcon">
          <MessageIcon />
        </View>
        <View UNSAFE_className="heading-noActiveCases" marginTop={8}>
          <Text>No active case</Text>
        </View>
        <View UNSAFE_className="noActiveCases-description" marginTop={6}>
          <Text>There are no active cases at this time.</Text>
        </View>
        {isCaseTab && <View UNSAFE_className="noActiveCases-description">
          <Text>
            You can view the past cases from <a href="" className="case-history-tab-link" onClick={e => switchHistoryTab(e)}>history tab.</a>
          </Text>
        </View>}
      </View>
    </>
  );
};

export default NoActiveCase;